// import React, { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import Container from "../../assets/Container.png";
// import { FaCalendarAlt } from "react-icons/fa";
// import { FaRegFolderOpen, FaArrowRight } from "react-icons/fa6";
// import UserHeader from "../../components/common/UserHeader";
// import banner from "../../assets/headerBanner.png";
// import axios from "axios";
// import Loader from "../../components/common/Loader";
// import AOS from "aos";
// import "aos/dist/aos.css";

// const BlogList = () => {
//   const [blogList, setBlogList] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const navigate = useNavigate();

//   useEffect(() => {
//     AOS.init({ duration: 1000, once: true });
//     allBlogs();
//   }, []);

//   const allBlogs = async () => {
//     try {
//       setIsLoading(true);
//       const res = await axios.get(
//         `${process.env.REACT_APP_API_URL}/blog-post/get-all-blogs`
//       );
//       setBlogList(res.data || []);
//     } catch (err) {
//       console.error("Error fetching blogs:", err);
//       setError("Failed to load blogs. Please try again later.");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return "Unknown Date";
//     const options = { year: "numeric", month: "long", day: "numeric" };
//     return new Date(dateString).toLocaleDateString(undefined, options);
//   };

//   return (
//     <>
//       <UserHeader headerImg={banner} pageName="Blog List" mainText="Home" />

//       {isLoading ? (
//         <div className="py-10 px-4 md:px-10">
//           <div className="rounded-md flex tracking-wider font-semibold justify-center items-center border border-slate-400 p-4">
//             <Loader /> <span className="ml-2">Please Wait...</span>
//           </div>
//         </div>
//       ) : error ? (
//         <div className="py-10 px-4 md:px-10">
//           <div className="rounded-md flex tracking-wider font-semibold justify-center items-center border border-red-400 p-4 text-red-600">
//             {error}
//           </div>
//         </div>
//       ) : blogList.length === 0 ? (
//         <div className="py-10 px-4 md:px-10">
//           <div className="rounded-md flex tracking-wider font-semibold justify-center items-center border border-slate-400 p-4">
//             No blogs available.
//           </div>
//         </div>
//       ) : (
//         <div className="grid grid-cols-1 lg:grid-cols-4 items-start gap-6 py-10 px-4 md:px-10">
//           {blogList.map((blog, i) => (
//             <div
//               key={blog._id}
//               onClick={() => navigate(`/blog/${blog._id}`)}
//               data-aos={i % 2 === 0 ? "zoom-in-right" : "zoom-out-left"}
//               className="bg-white shadow-lg rounded-2xl overflow-hidden w-full cursor-pointer hover:shadow-xl transition-all duration-300"
//             >
//               {/* Blog Image */}
//               <div className="w-full h-64 bg-gray-200 flex items-center justify-center overflow-hidden">
//                 <img
//                   src={blog.image?.[0] || Container}
//                   alt={blog.title || "Blog image"}
//                   className="w-full h-full object-cover object-center transition-transform duration-500 ease-out hover:scale-110"
//                 />
//               </div>

//               {/* Blog Details */}
//               <div className="p-5 flex flex-col gap-3">
//                 <div className="flex flex-wrap gap-4 text-gray-600 text-sm">
//                   <div className="flex items-center gap-2">
//                     <FaCalendarAlt className="text-[#2F9BD6]" />
//                     <span>{formatDate(blog.dateOfPublish)}</span>
//                   </div>

//                   <div className="flex items-center gap-2">
//                     <FaRegFolderOpen className="text-[#2F9BD6]" />
//                     <span>{blog.author || "Admin"}</span>
//                   </div>
//                 </div>

//                 <h3 className="text-[17px] font-semibold text-[#1C1C25]">
//                   {blog.title}
//                 </h3>

//                 {/* <div
//                        className="text-gray-700 text-sm leading-relaxed overflow-hidden line-clamp-3"
//                        dangerouslySetInnerHTML={{
//                          __html: blog.description?.[0] || "<p>No description available.</p>",
//                        }}
//                      /> */}
//               </div>
//             </div>
//           ))}
//         </div>
//       )}
//     </>
//   );
// };

// export default BlogList;


import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Container from "../../assets/Container.png";
import { FaCalendarAlt } from "react-icons/fa";
import { FaRegFolderOpen } from "react-icons/fa6";
import UserHeader from "../../components/common/UserHeader";
import banner from "../../assets/headerBanner.png";
import axios from "axios";
import Loader from "../../components/common/Loader";
import AOS from "aos";
import "aos/dist/aos.css";
import SEO from "../../components/common/SEO";

const BlogList = () => {
  const [blogList, setBlogList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
    allBlogs();
  }, []);

  const allBlogs = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/blog-post/get-all-blogs`
      );
      
      const validBlogs = res.data.filter(blog => blog.title);
      const blogsWithSlugs = validBlogs.map(blog => {
        if (!blog.slug) {
          blog.slug = blog.title
            .toLowerCase()
            .replace(/[^a-zA-Z0-9\s]/g, '')
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-')
            .trim();
        }
        return blog;
      });
      
      setBlogList(blogsWithSlugs || []);
    } catch (err) {
      console.error("Error fetching blogs:", err);
      setError("Failed to load blogs. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "Unknown Date";
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const handleBlogClick = (blog) => {
    navigate(`/blog/${blog.slug || blog._id}`);
  };

  return (
    <>
      <SEO 
        title="Blogs"
        description="Read our latest blogs on company registration, GST, ITR filing, and business solutions."
        keywords="business blogs, company registration blog, GST blog, ITR blog"
      />

      <UserHeader headerImg={banner} pageName="Blog List" mainText="Home" />

      {isLoading ? (
        <div className="py-10 px-4 md:px-10">
          <div className="rounded-md flex tracking-wider font-semibold justify-center items-center border border-slate-400 p-4">
            <Loader /> <span className="ml-2">Please Wait...</span>
          </div>
        </div>
      ) : error ? (
        <div className="py-10 px-4 md:px-10">
          <div className="rounded-md flex tracking-wider font-semibold justify-center items-center border border-red-400 p-4 text-red-600">
            {error}
          </div>
        </div>
      ) : blogList.length === 0 ? (
        <div className="py-10 px-4 md:px-10">
          <div className="rounded-md flex tracking-wider font-semibold justify-center items-center border border-slate-400 p-4">
            No blogs available.
          </div>
        </div>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-4 items-start gap-6 py-10 px-4 md:px-10">
          {blogList.map((blog, i) => (
            <div
              key={blog._id}
              onClick={() => handleBlogClick(blog)}
              data-aos={i % 2 === 0 ? "zoom-in-right" : "zoom-out-left"}
              className="bg-white shadow-lg rounded-2xl overflow-hidden w-full cursor-pointer hover:shadow-xl transition-all duration-300 group"
            >
              <div className="w-full h-64 bg-gray-200 flex items-center justify-center overflow-hidden relative">
                <img
                  src={blog.image?.[0] || Container}
                  alt={blog.title || "Blog image"}
                  className="w-full h-full object-cover object-center transition-transform duration-500 ease-out group-hover:scale-110"
                />
                <div className="absolute bottom-2 right-2 bg-black/60 text-white text-xs px-2 py-1 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  /{blog.slug || blog._id}
                </div>
              </div>

              <div className="p-5 flex flex-col gap-3">
                <div className="flex flex-wrap gap-4 text-gray-600 text-sm">
                  <div className="flex items-center gap-2">
                    <FaCalendarAlt className="text-[#2F9BD6]" />
                    <span>{formatDate(blog.dateOfPublish)}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <FaRegFolderOpen className="text-[#2F9BD6]" />
                    <span>{blog.author || "Admin"}</span>
                  </div>
                </div>
                <h3 className="text-[17px] font-semibold text-[#1C1C25] line-clamp-2">
                  {blog.title}
                </h3>
                {blog.metaDescription && (
                  <p className="text-sm text-gray-500 line-clamp-2">
                    {blog.metaDescription}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default BlogList;